<template>
    <div class="main">
        <c-panel title="EVENTOS DO CALENDÁRIO" titleIcon="fas fa-calendar-alt">

            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Dia letivo e dia trabalhado são independentes: a Semana Pedagógica é trabalhada e não letiva; o sábado letivo é as duas coisas; feriado não é nenhuma."></el-alert>

            <el-row class="u-mb-15" :gutter="10">
                <el-col :xs="24" :sm="8">
                    <el-input v-model="filtro.nome" placeholder="Pesquisar evento..." @keyup.native.enter="carregar"></el-input>
                </el-col>
                <el-col :xs="12" :sm="5">
                    <el-select v-model="filtro.tipo" clearable placeholder="Tipo" style="width: 100%;" @change="carregar">
                        <el-option v-for="t in tipos" :key="t" :value="t" :label="rotuloTipo(t)"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="12" :sm="5">
                    <el-select v-model="filtro.periodo_letivo_id" placeholder="Período" style="width: 100%;" @change="carregar">
                        <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="6" class="u-text-right">
                    <router-link v-if="podeEscrever" to="/admin/evento-calendario/cadastro" class="btn-new-register">
                        <el-button type="primary">NOVO EVENTO</el-button>
                    </router-link>
                </el-col>
            </el-row>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Evento</th>
                            <th class="hidden-mobile">Tipo</th>
                            <th>Período</th>
                            <th class="u-text-center">Letivo</th>
                            <th class="u-text-center hidden-mobile">Trabalhado</th>
                            <th class="hidden-mobile">Público-alvo</th>
                            <th class="u-text-center">Escopo</th>
                            <th style="width: 120px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="item in items" :key="item.id">
                            <td>
                                {{ item.nome }}
                                <span v-if="item.sugerido_smed" class="detalhe">sugerido pela SMED</span>
                            </td>
                            <td class="hidden-mobile">{{ rotuloTipo(item.tipo) }}</td>
                            <td>{{ item.data_inicio | data }} <span v-if="item.data_fim !== item.data_inicio">a {{ item.data_fim | data }}</span></td>
                            <td class="u-text-center">{{ item.dia_letivo ? 'Sim' : 'Não' }}</td>
                            <td class="u-text-center hidden-mobile">{{ item.dia_trabalhado ? 'Sim' : 'Não' }}</td>
                            <td class="hidden-mobile">{{ (item.publico_alvo || []).join(', ') }}</td>
                            <td class="u-text-center">{{ rotuloEscopo(item.escopo) }}</td>
                            <td class="u-text-center acao">
                                <router-link v-if="podeEscrever" :to="'/admin/evento-calendario/edit/' + item.id" class="link-icon u-mr-10" style="color: rgba(0, 0, 0, 0.87) !important;">
                                    <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                                </router-link>
                                <el-button v-if="podeEscrever" @click="excluir(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                                <span v-if="!podeEscrever">—</span>
                            </td>
                        </tr>
                        <tr v-if="items.length === 0"><td colspan="8" class="u-text-center">Nenhum evento cadastrado.</td></tr>
                    </tbody>
                </table>
                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>

                <el-row :gutter="10" v-if="statusList">
                    <el-col :xs="24" :sm="12">
                        <div class="u-text-left u-mt-10">Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros.</div>
                    </el-col>
                    <el-col :xs="24" :sm="12" v-if="paginate.qtdItens > 30">
                        <div class="u-text-right">
                            <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens"
                                @current-change="irPara" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </c-panel>
    </div>
</template>
<script>
/**
 * BLOCO C — itens 37, 38, 39 e 42. Interface para `api/evento-calendario`.
 * A regra de dia letivo efetivo e o fluxo de aceite são do backend.
 */
import { periodosLetivosMixin } from '@/shared/periodos-letivos'
export default {
    mixins: [periodosLetivosMixin],
    filters: {
        data (v) { return v ? String(v).substring(0, 10).split('-').reverse().join('/') : '—' }
    },
    data: () => ({
        statusList: false,
        filtro: { nome: '', tipo: '', periodo_letivo_id: null },
        paginate: { page: 1, qtdItens: null, from: '', to: '' },
        items: [],
        tipos: [],
    }),
    computed: {
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () {
        this.filtro.periodo_letivo_id = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : null

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/evento-calendario/initForm`,
            this.$store.getters.getHeaderAuth)
            .then(r => { this.tipos = (r.data && r.data.tipos) ? r.data.tipos : [] }).catch(() => {})

        this.carregar()
    },
    methods: {
        carregar () {
            this.statusList = false
            this.items = []
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/evento-calendario/getAllPaginate?page=${this.paginate.page}`,
                this.filtro, this.$store.getters.getHeaderAuth
            ).then(r => {
                this.items = r.data.data || []
                this.paginate.qtdItens = r.data.total
                this.paginate.from = r.data.from
                this.paginate.to = r.data.to
                this.statusList = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        irPara (p) { this.paginate.page = p; this.carregar() },
        rotuloTipo (t) {
            const r = { feriado_nacional: 'Feriado nacional', feriado_estadual: 'Feriado estadual',
                feriado_municipal: 'Feriado municipal', recesso: 'Recesso', ponto_facultativo: 'Ponto facultativo',
                paralisacao: 'Paralisação', evento_escolar: 'Evento escolar', avaliacao: 'Avaliação',
                formacao: 'Formação', reuniao: 'Reunião', outros: 'Outros' }
            return r[t] || t
        },
        rotuloEscopo (e) {
            return { rede: 'Rede', instituicao: 'Escola', matriz_curricular: 'Matriz' }[e] || e
        },
        excluir (id) {
            this.$confirm('Excluir este evento?', 'Confirmação', {
                confirmButtonText: 'Excluir', cancelButtonText: 'Cancelar', type: 'warning'
            }).then(() => {
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/evento-calendario/delete/${id}`,
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Evento excluído.', type: 'success' })
                    this.carregar()
                }).catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
<style scoped>
.detalhe { display: block; font-size: 11px; color: #666; font-style: italic; }
</style>
